<div class="isg-menuv-container">
  <nav class="isg-menuv-nav">
    <ul class="isg-menuv" role="menu" aria-orientation="vertical">

      <ng-container [ngTemplateOutlet]="templateMenuVertical"
                    [ngTemplateOutletContext]="{ items : menuItems, level: 1 }">

      </ng-container>

    </ul>
  </nav>
</div>

<ng-template #templateMenuVertical let-items="items" let-level="level">

  <ng-container *ngFor="let item of items">

    <ng-container *ngIf="item.hasChildren">
      <ng-container [ngTemplateOutlet]="showChildren"
                    [ngTemplateOutletContext]="{ item: item, level: level }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!item.hasChildren">
      <ng-container [ngTemplateOutlet]="elseNoChildren"
                    [ngTemplateOutletContext]="{ item: item, level: level }">
      </ng-container>
    </ng-container>

  </ng-container>

</ng-template>

<ng-template #showChildren let-item="item" let-level="level">
  <li role="menuitem" class="isg-mitem-haschildren"
      attr.level="{{assignLevel(item, level)}}"
      [ngClass]="{'isg-mitem-top': level == 1, 'isg-mitem-expanded': item.expanded, 'isg-mitem-expanded-current' : item.currExpanded , 'selected': item.selected}"
      attr.aria-label="{{item.name}}">
    <div *ngIf="level == 1" class="isg-mitem-content">
      <span [ngClass]="getImageClass(item)"></span>
      <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
      <span class="k-spacer"></span>
      <span class="k-icon"></span>
    </div>
    <div *ngIf="level > 1" class="isg-mitem-content" (click)="toggleSubmenu($event, item)">
      <span [ngClass]="getImageClass(item)"></span>
      <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
      <span class="k-spacer"></span>
      <span class="fa-solid" [ngClass]="{'fa-chevron-down': item.expanded, 'fa-chevron-right': !item.expanded}"></span>
    </div>
    <ul role="menu" class="isg-mitem-children" [ngClass]="{'hidden' : !item.expanded && level > 1 }">
      <ng-container [ngTemplateOutlet]="templateMenuVertical"
                    [ngTemplateOutletContext]="{ items : item.children , level: level + 1 }">
      </ng-container>
    </ul>
  </li>
</ng-template>

<ng-template #elseNoChildren let-item="item" let-level="level">
  <li role="menuitem"
      [ngClass]="{'isg-mitem-top': level == 1, 'isg-mitem-bookmark': isBookmark(item), 'selected': item.selected }"
      attr.level="{{assignLevel(item, level)}}"
      attr.aria-label="{{item.name}}">
    <ng-container *ngIf="!(item.url) || item.url.length < 1">
      <ng-container [ngTemplateOutlet]="noRoute"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(item.url) && item.url.length > 0 && isItemRouteInternal(item.url)">
      <ng-container [ngTemplateOutlet]="routeInternal"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="(item.url) && item.url.length > 0 && !isItemRouteInternal(item.url)">
      <ng-container [ngTemplateOutlet]="routeExternal"
                    [ngTemplateOutletContext]="{ item: item }">
      </ng-container>
    </ng-container>
  </li>
</ng-template>
 
<ng-template #noRoute let-item="item">
  <div class="isg-mitem-content" >
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </div>
</ng-template>

<ng-template #routeInternal let-item="item">
  <a class="isg-mitem-content" routerLink="{{item.url}}" >
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </a>
</ng-template>

<ng-template #routeExternal let-item="item">
  <a class="isg-mitem-content" href="{{item.url}}" target="{{item.target}}">
    <span [ngClass]="getImageClass(item)"></span>
    <span class="isg-mitem-text" data-id="{{item.id}}">{{item.name}}</span>
    <span class="k-spacer"></span>
    <span class="k-icon k-i-none"></span>
  </a>
</ng-template>



